// src/pages/Home.tsx
import React from 'react';
import AnimationPage from '../components/Animation';


const Home: React.FC = () => (
  <AnimationPage />
);

export default Home;